// ============================================================
// components/catalogo/FacturacionForm.jsx — Modal editar regla de facturación
// ============================================================

import React, { useState } from 'react';

function FacturacionForm({ regla, onSave, onClose }) {
  const [form, setForm] = useState({
    mode: regla.mode || 'Mes vencido',
    description: regla.description || '',
    active: regla.active !== undefined ? regla.active : true
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!form.description.trim()) {
      setError('La descripción para la IA es obligatoria');
      return;
    }
    setSaving(true);
    setError(null);

    const result = await onSave(form);
    setSaving(false);

    if (!result.ok) {
      setError(result.error || 'Error al guardar');
    }
  };

  return (
    <div className="cat-modal-overlay" onClick={onClose}>
      <div className="cat-modal cat-modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="cat-modal-header">
          <h2>Editar regla — {regla.zone}</h2>
          <button className="cat-btn-icon" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div className="cat-modal-body">
          <div className="cat-form-group">
            <label>Zona</label>
            <input type="text" value={regla.zone} disabled className="cat-input-disabled" />
            <p className="cat-form-hint">La zona no se puede cambiar. Para agregar zonas nuevas, contactar administrador.</p>
          </div>

          <div className="cat-form-group">
            <label>Modalidad de facturación</label>
            <select value={form.mode} onChange={(e) => handleChange('mode', e.target.value)}>
              <option value="Mes vencido">Mes vencido</option>
              <option value="Mes adelantado">Mes adelantado</option>
            </select>
          </div>

          <div className="cat-form-group">
            <label>Descripción para la IA</label>
            <textarea
              value={form.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Texto que la IA usará para explicar la facturación al cliente"
              rows={4}
            />
            <p className="cat-form-hint">
              Este texto se inyecta directo en [REGLAS_FACTURACION]. Escribilo como si la IA se lo explicara al cliente.
            </p>
          </div>

          <div className="cat-form-group">
            <label className="cat-checkbox-label">
              <input
                type="checkbox"
                checked={form.active}
                onChange={(e) => handleChange('active', e.target.checked)}
              />
              Regla activa
            </label>
          </div>

          {error && <div className="cat-form-error">{error}</div>}
        </div>

        <div className="cat-modal-footer">
          <button className="cat-btn-secondary" onClick={onClose}>Cancelar</button>
          <button
            className="cat-btn-primary"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? 'Guardando...' : 'Guardar cambios'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FacturacionForm;
